const initialState = {
  job: {
    dynamic_job_data:{},
    generate_assessment: null,
  },
  fieldErrors: {}, // Add field errors state
};
export default initialState;
